"use client"

import { ActionIcon, Button, Combobox, createTheme, Menu, Modal, Overlay, Portal, Tooltip, type MantineColorsTuple } from "@mantine/core"

const rBackBlue: MantineColorsTuple = ["#ebf9ff", "#d6effb", "#a8def8", "#78cdf7", "#58bef5", "#48b6f5", "#3fb1f6", "#339bdb", "#2589c4", "#0077ad"]

const rBackBlueDarkMode: MantineColorsTuple = ["#f0f4f9", "#e0e4ed", "#bcc7db", "#96a8cb", "#768ebd", "#627eb4", "#5675b1", "#47649c", "#3d598c", "#314c7d"]

const rPaleBackground: MantineColorsTuple = ["#f8f6fe", "#f1edfd", "#ddd5f6", "#b9a7ee", "#9376e8", "#744ce3", "#6033e0", "#5626df", "#471bc6", "#3e17b1"]

export const theme = createTheme({
  primaryColor: "rBackBlue",
  primaryShade: 8,
  // autoContrast: true,
  // luminanceThreshold: 0.5,
  // fontFamily: "GeistSans",
  // fontFamilyMonospace: "GeistMono",
  colors: {
    rBackBlue,
    rBackBlueDarkMode,
    rPaleBackground,
  },
  components: {
    Portal: Portal.extend({
      defaultProps: {
        // Added for performance: https://mantine.dev/changelog/7-17-0/
        reuseTargetNode: true,
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        centered: true,
        size: "md",
        overlayProps: {
          backgroundOpacity: 0.55,
          blur: 3,
        },
      },
    }),
    Button: Button.extend({
      defaultProps: {
        color: "rBackBlue.9",
        radius: "sm",
        size: "sm",
        variant: "filled",
      },
    }),
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        color: "rBackBlue.9",
        size: "lg",
        radius: "md",
        variant: "filled",
      },
    }),
    Menu: Menu.extend({
      defaultProps: {
        shadow: "md",
        withArrow: true,
        offset: 5,
      },
    }),
    Combobox: Combobox.extend({
      defaultProps: {
        shadow: "md",
        withArrow: true,
        offset: 5,
      },
    }),
    Overlay: Overlay.extend({
      defaultProps: {
        backgroundOpacity: 0.55,
        blur: 3,
      },
    }),
    Tooltip: Tooltip.extend({
      defaultProps: {
        withArrow: true,
        position: "bottom",
        openDelay: 500,
        zIndex: 1000,
      },
      styles: {
        tooltip: {
          backgroundColor: "var(--mantine-color-white)",
          color: "var(--mantine-color-text)",
          border: "1px solid var(--mantine-color-gray-2)",
          boxShadow: "var(--mantine-shadow-lg)",
        },
      },
    }),
  },
})
